module.exports = __webpack_public_path__ + "static/arrows-592347cd26f818597eef8b5026d25a6e.gif";